import { defineStore } from "pinia";
import { useLocationTermStore } from "./locationTermStore";
import Bugsnag from "@bugsnag/js";

export const useLocationsStore = defineStore("locationsStore", {
  state: () => ({
    loading: false,
    detailExpanded: false,
    focusedLocation: null,
    noResultsFromSearch: false,
    locations: [],
  }),

  actions: {
    fetchLocationsFromLatLon(latitude, longitude, bounds) {
      return fetch(
        `/simulator_locations.json?latitude=${latitude}&longitude=${longitude}&bounds=${bounds.toUrlValue()}`,
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data.locations.length === 0) {
            this.$patch({
              locations: [],
              noResultsFromSearch: true,
              loading: false,
            });
          } else {
            this.$patch({
              locations: data.locations,
              noResultsFromSearch: false,
              loading: false,
            });
          }
        })
        .catch((error) => {
          Bugsnag.notify(error);
        });
    },
  },
});
